import styles from "./Avatar.module.css";

interface AvatarProps {
  src: string;
  isVisible?: boolean;
}

const Avatar = ({ src, isVisible }: AvatarProps) => {
  return (
    <>
      {isVisible && (
        <img
          src={src}
          alt="Chattbot avatar"
          className={styles.avatar}
        />
      )}
    </>
  );
};

export default Avatar;
